import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoggingService } from '@logging/logging.service';
import { UnityCookieService } from '@utils/unity-cookie.service';
import { environment } from '@env/environment';
import { ActiveUser } from './models/active-user.model';

@Injectable({ providedIn: 'root' }) 
export class ActiveUserDataProvider {
  constructor(
    protected httpClient: HttpClient,
    protected logger: LoggingService,
    protected cookieService: UnityCookieService
  ) {
  }

  protected apiRoot = `${environment.apiPaths.root}tenant/`;

  fetchActiveUser$(userId: string, tenantId: string): Observable<ActiveUser> {
    this.logger.trace('ActiveUserDataProvider: fetching active user', userId, tenantId);
    const root = this.apiRoot + tenantId + '/user/' + userId;
    return this.httpClient.get<ActiveUser>(root);
  }
} 